// extracted by mini-css-extract-plugin
export var content = "ovvvr";
export var firstRow = "iTqd0";
export var firstRowBase = "hQj7T";
export var firstRowThreeColumnNext = "gCSJa";
export var firstRowThreeColumnUnreadNext = "ukpDB";
export var mailListItem = "lHRXq";
export var mailListItemContainer = "jGG6V";
export var mailListItemRPRightPadding = "V9pSM";
export var mailListItemRightPadding = "CgZeR";
export var showDeleteOnHover = "hDNlA";
export var singleLineViewContainer = "ZTnQq";
export var subject = "gmffI";
export var subjectUnread = "yg0l0";
export var unreadBarGrow = "kOMna";
export var unreadMailListItem = "DLvHz";
export var unreadMailListItemDarker = "IMyk_";